import {combineReducers} from "redux";

const reducers = ["dialogs", "user", "attachments"];

export default combineReducers(
    reducers.reduce((initial, name) => {
        initial[name] = require(`./${name}`).default;
        return initial;
    }, {})
);
